import { StyledTable } from './StyledTableComponents';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultTableComponent = ({
  children,
  requiredTableProps,
  zebraStripe = false,
  frozenOffsets,
  condensed = true,
  dataDensity
}) => {
  return /*#__PURE__*/_jsx(StyledTable
  // Overrides contextual styles when rendered in a card
  , Object.assign({
    bordered: true,
    condensed: condensed,
    dataDensity: dataDensity,
    flush: true,
    responsive: false
  }, requiredTableProps, {
    zebraStripe: zebraStripe,
    frozenOffsets: frozenOffsets,
    children: children
  }));
};